import backgroundImage from '@assets/auth-background.jpg'

export function ErrorBoundaryFallback() {
  return (
    <div
      style={{
        height: '100vh',
        background: 'white',
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: '60% 100%',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div
        style={{
          display: 'grid',
          justifyContent: 'end',
          alignItems: 'center',
          width: '100%',
          height: '100%',
          background: `linear-gradient(270deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 1) 40%, rgba(255, 255, 255, 0) 70% ,rgba(255, 255, 255, 0) 100%)`,
        }}
      >
        <div style={{ marginRight: 64 }}>
          <p style={{ fontSize: '3rem' }}>Something went wrong</p>
        </div>
      </div>
    </div>
  )
}
